// extracted by mini-css-extract-plugin
export var label = "_h3-2";
export var slideContainer = "_h3-0";
export var slider = "_h3-1";